<div class="body">
  <div
    class="afiliado"
    *ngIf="
      rol == 'ROLE_ADMINISTRADOR' ||
      rol == 'ROLE_CONTABILIDAD' ||
      rol == 'ROLE_ENCARGADO_REGIONAL_CONTABLE' ||
      rol == 'ROLE_ENCARGADO_CONTABILIDAD'
    "
  >
    <div class="container" style="height: 100px"></div>
 
    <div
      class="container"
      id="tabla"
      style="background-color: white; padding-top: 50px; padding-bottom: 50px"
    >     
      <div class="row">
        <div class="col-lg-6"></div>

        <div class="col-lg-3"></div>
      </div>
      <hr />
      <br />
      <div class = "table-responsive">
        <tr>
          <td class="col-lg-1" ></td>
  
          <td class="col-lg-4">
            <h1> ¿Qué listado le gustaría descargar?</h1>
          </td>
          <td class="col-lg-1" >
          
          </td>
          <td class="col-lg-1 col-xs-1"></td>
          <td class="col-lg-1 col-xs-1"></td>
          <td class="col-lg-1 col-xs-1"></td>
          <td class="col-lg-1 col-xs-1"></td>
        </tr>
        

      </div>
    
      <div class = "table-responsive">
        <tr>
        <td class="col-lg-1 col-xs-1"></td>
        <td class="col-lg-3">
          <button
          class="btn btn-success"
          (click)="pendienteAfiliacion()"
          >
         Pendiente afiliación 
        </button>

        </td>
      
        <td class="col-lg-3">
          <button
            class="btn btn-success"
            (click)="pendienteDesaAfiliacion()"
          >
          Pendiente Desafiliación 
          </button>
        </td>
        <td class="col-lg-1 col-xs-1"></td>
        <td class="col-lg-1 col-xs-1"></td>
        <td class="col-lg-1 col-xs-1"></td>
        <td class="col-lg-1 col-xs-1"></td>
      </tr>
      </div>
      <br />
     
      <div class="row">
        <div class="col-lg-8"></div>
      </div>
    </div>

    <div class="container" style="height: 100px"></div>
  </div>
</div>
